export function handlePendingReviewButton(node, hide){
    if(hide){
        //hide the element
        node.style.display = "none"
    } else {
        //display the element
        node.style.display = "block"
    }
}